import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api";

const EventContext = createContext(null);
const KEY = "jjs_demo_phase";

export function EventProvider({ children }) {
  const [event, setEvent] = useState(null);
  const [demoPhase, setDemo] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    api.get("/events/active").then(({ data }) => setEvent(data)).catch(() => {});
  }, []);

  const setDemoPhase = (p) => {
    if (p) { localStorage.setItem(KEY, p); } else { localStorage.removeItem(KEY); }
    setDemo(p);
  };

  const realPhase = event?.phase || "pre_event";
  const effectivePhase = demoPhase || realPhase;
  const checkinAllowed = demoPhase ? demoPhase === "live_event" : !!event?.checkin_allowed;

  return (
    <EventContext.Provider value={{ event, realPhase, effectivePhase, demoPhase, setDemoPhase, checkinAllowed }}>
      {children}
    </EventContext.Provider>
  );
}

export const useEvent = () => useContext(EventContext) || { event: null, realPhase: "pre_event", effectivePhase: "pre_event", demoPhase: null, setDemoPhase: () => {}, checkinAllowed: false };
